import "./IncidentResponse.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function IncidentResponsePage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <Footer />
    </div>;
}